import React from "react";
import moment from "moment";
import { Image, Popover, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { imgStringToArray } from "../../../components/common/common-column-components/common-edit-image-component";

const ImageWithHoverPreview = ({ url }: { url: string }) => {
  return (
    <Popover
      content={
        <Image
          src={url}
          preview={false}
          style={{ width: "800px", objectFit: "contain" }}
        />
      }
      trigger="hover"
      overlayStyle={{ zIndex: 99999 }}
      mouseEnterDelay={0.3}
      mouseLeaveDelay={0.1}
      placement="right"
      autoAdjustOverflow={true}
      getPopupContainer={() => document.body}
    >
      <Image
        style={{ cursor: "pointer" }}
        width={100}
        src={url}
        preview={false}
      />
    </Popover>
  );
};

interface ProductionOverrunColumnModelProps {
  onEditClick?: (rowData: any) => void;
}

export default function ProductionOverrunColumnModel({
  onEditClick,
}: ProductionOverrunColumnModelProps = {}) {
  return [
    {
      title: "Product Image / 产品图片",
      field: "images",
      width: 150,
      render: (row: any) => {
        if (!row.images) {
          return "-";
        }
        const fileList = imgStringToArray(row.images);
        if (!fileList || fileList.length === 0) {
          return "-";
        }
        return (
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {fileList.map((file: any, index: number) => (
              <ImageWithHoverPreview key={index} url={file.url} />
            ))}
          </div>
        );
      },
    },
    {
      title: "Product Name / 产品名称",
      field: "productName",
      width: 200,
      render: (row: any) => row.productName || "-",
    },
    {
      title: "Total Overrun Quantity / 累计多出数量",
      field: "totalOverrunQuantity",
      width: 180,
      render: (row: any) => (
        <span
          style={{
            color: row.totalOverrunQuantity > 0 ? "#f5222d" : "#52c41a",
            fontWeight: 600,
          }}
        >
          {row.totalOverrunQuantity || 0}
        </span>
      ),
    },
    {
      title: "Last Order Date / 最后订单时间",
      field: "lastOrderDate",
      width: 160,
      render: (row: any) =>
        row.lastOrderDate
          ? moment(row.lastOrderDate).format("YYYY/MM/DD HH:mm")
          : "-",
    },
    {
      title: "Last Employee Name / 最后操作人",
      field: "lastEmployeeName",
      width: 180,
      render: (row: any) => row.lastEmployeeName || "-",
    },
    {
      title: "Actions / 操作",
      field: "actions",
      width: 120,
      render: (row: any) => {
        if (!onEditClick) {
          return "-";
        }
        return (
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={(event) => {
              event?.stopPropagation?.();
              onEditClick(row);
            }}
            style={{
              background: "#1976D2",
              borderColor: "#1976D2",
              color: "#ffffff",
              fontWeight: 500,
              padding: "0 16px",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            编辑 / Edit
          </Button>
        );
      },
    },
  ];
}

